import * as React from 'react';
import { Button, Box, TextField, InputLabel, MenuItem, FormControl,
   Select } from "@mui/material";
import CheckIcon from '@mui/icons-material/Check';
import { SERVER_URL } from "../app/constant";
import { useToken } from "../auth/useToken";

const STATIONS = [
  { value: 'calgary', label: 'Calgary' },
  { value: 'edmonton', label: 'Edmonton' },
  { value: 'kamloops', label: 'Kamloops' },
  { value: 'kelowna', label: 'Kelowna' },
  { value: 'princeGeorge', label: 'Prince George' },
  { value: 'vancouver', label: 'Vancouver' },
  { value: 'victoria', label: 'Victoria' },
  { value: 'winnipeg', label: 'Winnipeg' },
  { value: 'fredericton', label: 'Fredericton' },
  { value: 'moncton', label: 'Moncton' },
  { value: 'saintJohn', label: 'Saint John' },
  { value: 'cornerBrook', label: 'Corner Brook' },
  { value: 'gooseBay', label: 'Goose Bay' },
  { value: 'grandFalls', label: 'Grand Falls' },
  { value: 'stJohns', label: "St. John's" },
  { value: 'inuvik', label: 'Inuvik' },
  { value: 'yellowknife', label: 'Yellowknife' },
  { value: 'halifax', label: 'Halifax' },
  { value: 'sydney', label: 'Sydney' },
  { value: 'iqaluit', label: 'Iqaluit' },
  { value: 'barrie', label: 'Barrie' },
  { value: 'kingston', label: 'Kingston' },
  { value: 'kitchenerWaterloo', label: 'Kitchener-Waterloo' },
  { value: 'london', label: 'London' },
  { value: 'ottawa', label: 'Ottawa' },
  { value: 'peterborough', label: 'Peterborough' },
  { value: 'sudbury', label: 'Sudbury' },
  { value: 'thunderBay', label: 'Thunder Bay' },
  { value: 'toronto', label: 'Toronto' },
  { value: 'windsor', label: 'Windsor' },
  { value: 'charlottetown', label: 'Charlottetown' },
  { value: 'montreal', label: 'Montreal' },
  { value: 'northQuebec', label: 'North Quebec' },
  { value: 'quebecCity', label: 'Quebec City' },
  { value: 'regina', label: 'Regina' },
  { value: 'saskatoon', label: 'Saskatoon' },
  { value: 'whitehorse', label: 'Whitehorse' },
];

const menuItemSx = {
  "&:hover": {
    backgroundColor: "#E4E4E4",
  },
  "&.Mui-selected:hover": {
    backgroundColor: "#E4E4E4",
  },
  "&:focus, &:focus-visible, &.Mui-focusVisible": {
    outline: "2px solid #1976D2",
    outlineOffset: "-2px",
  },
  "&.Mui-selected:focus, &.Mui-selected:focus-visible, &.Mui-selected.Mui-focusVisible": {
    outline: "2px solid #1976D2",
    outlineOffset: "-2px",
  },
};

function SimulatePage() {
  const [token, setToken] = useToken();
  const [radioOneStation, setStation] = React.useState("");
  const [statusMessage, setStatusMessage] = React.useState("");

  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const handleResetOnboarding = () => {
    setStatusMessage("");
    fetch(`${SERVER_URL}/reset-onboard`, requestOptions)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to reset onboarding.");
        }
        setStatusMessage("Onboarding reset.");
      })
      .catch((error) => {
        setStatusMessage(error.message);
      });
  };

  const handleFirstTime = () => {
    setStatusMessage("");
    fetch(`${SERVER_URL}/reset-first-time`, requestOptions)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Failed to reset first time experience.");
      }
      setStatusMessage("First time experience reset.");
    })
    .catch((error) => {
      setStatusMessage(error.message);
    });
  };
  

  const handleRadioStation = () => {
    requestOptions.body = JSON.stringify({"station": radioOneStation})
    setStatusMessage("");
    fetch(`${SERVER_URL}/reset-station`, requestOptions)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Failed to save Radio One station.");
      }
      setStatusMessage("Radio One station saved.");
    })
    .catch((error) => {
      setStatusMessage(error.message);
    });
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        flexDirection: "column",
      }}
    >
      <h1>Simulate</h1>
      {statusMessage && (
        <div className="fail" role="alert">
          {statusMessage}
        </div>
      )}
      {/* <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          mt: 2,
        }}
      >
        <TextField
          id="outlined-multiline-static"
          label="Alexa Test Message"
          multiline
          sx={{ width: "40vw" }}
        />
        <Button variant="contained" sx={{ ml: 2, height: 58, width: 58 }}>
          Play
        </Button>
      </Box> */}
      <Button
        variant="contained"
        sx={{ width: "20vw", mt: 2 }}
        onClick={handleResetOnboarding}
      >
        Reset onboarding
      </Button>
      <Button
        variant="contained"
        sx={{ width: "20vw", mt: 2 }}
        onClick={handleFirstTime}
      >
        Reset first time experience
      </Button>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          mt: 2,
        }}
      >
        <FormControl fullWidth>
          <InputLabel id="select-label">
            Radio One Station
          </InputLabel>
          <Select
            labelId="select-label"
            id="select"
            value={radioOneStation}
            label="Radio One Station"
            sx={{
              width: "20vw",
              backgroundColor: "white",
              "& .MuiSelect-select": {
                display: "flex",
                alignItems: "center",
              },
              "&:hover": {
                backgroundColor: "#E4E4E4",
              },
              "&.Mui-focused": {
                outline: "2px solid #1976D2",
                outlineOffset: "2px",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#1976D2",
                borderWidth: "2px",
              },
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  "& .MuiMenuItem-root": menuItemSx,
                },
              },
            }}
            onChange={(event) => {setStation(event.target.value)}}
          >
            {STATIONS.map((station) => {
              const isSelected = radioOneStation === station.value;
              return (
                <MenuItem
                  key={station.value}
                  value={station.value}
                  sx={menuItemSx}
                >
                  {isSelected && (
                    <CheckIcon sx={{ mr: 1, fontSize: 20, color: "#1976D2" }} />
                  )}
                  {station.label}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
        <Button 
          variant="contained" 
          sx={{ ml: 2, height: 58, width: 58 }}
          onClick={handleRadioStation}
        >
          Save
        </Button>
      </Box>
    </Box>
  );
}

export default SimulatePage;
